import { Box, Button, Dialog } from "@mui/material";
import { useState } from "react";
export default function NDA({ open, onClose, onAgree }) {
  const [closeDialog, setCloseDialog] = useState(false);
  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="md">
      <Box sx={{ m: 3 }}>
        <p>
          <i>
            De toegang tot dit Elion installateursplatform rond flexibiliteitssturing en de opleidingen die daarvoor ter
            uwer beschikking gesteld worden, zijn onderworpen aan de aanvaarding van onderstaande, essentiële
            voorwaarden, zonder dewelke wij u geen toegang zouden geven:
          </i>
        </p>
        <ol>
          <li>
            <i>
              De gegevens om toegang te krijgen (login en paswoord) tot het installateursplatform zijn strikt
              persoonlijk en mogen niet ter beschikking worden gesteld aan medewerkers of aan derden.
            </i>
          </li>
          <br />
          <li>
            <i>
              De data die ter beschikking wordt gesteld op het installateursplatform is strikt vertrouwelijk en mag niet
              worden meegedeeld of getoond aan derden.
            </i>
          </li>
          <br />
          <li>
            <i>
              De gegevens om toegang te krijgen tot (de online academy) Rakoo (login en paswoord) zijn strikt
              persoonlijk en mogen niet ter beschikking worden gesteld aan medewerkers of aan derden.
            </i>
          </li>
          <br />
          <li>
            <i>
              Het flexibiliteitsstuursignaal (of enige ander apparaat, hardware, software .... ) die u ontvangt van of
              via Smart at Energy en/of Elindus, mogen niet en u mag ook niemand toelaten om dit stuursignaal te
              reverse-engineeren, te dupliceren, te repliceren, te kopiëren, in licentie te geven, te exploiteren, ... .
              U mag het stuursignaal niet zelfstandig gebruiken op andere, niet door Elindus/Smart at Energy
              voorafgaandelijk aanvaardde assets. Iedere inbreuk op deze bepaling geeft aanleiding tot een forfaitaire
              schadevergoeding begroot op 100.000 euro, onverminderd het recht van Elindus/Smart at Energy om een hogere
              vergoeding te bewijzen en te vorderen voor direct en/of indirect geleden schade, met inbegrip van maar
              niet beperkt tot winstderving, honoraria van advocaten en consultants, en/of nieuwheid van de uitvinding.
            </i>
          </li>
          <br />
          <li>
            <i>
              Smart at Energy/Elindus hebben toegang tot de handelingen die worden gesteld door de gebruikers op het
              installateursplatform, dit teneinde een kwaliteitsvolle opvolging te kunnen bieden aan de eindklant.
            </i>
          </li>
        </ol>
        <p>
          <i>
            <b>
              Door op “AANVAARDEN” te klikken bevestigt u dat u bovenstaande voorwaarden hebt gelezen en u hiermee
              uitdrukkelijk akkoord gaat.
            </b>
          </i>
        </p>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 3,
          }}
        >
          <Button
            variant="contained"
            sx={{ marginRight: 5 }}
            onClick={() => {
              onAgree(true);
              onClose();
            }}
          >
            AANVAARDEN
          </Button>
          <Button
            onClick={() => {
              onAgree(false);
              onClose();
            }}
          >
            AFWIJZEN
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
